module.exports = __webpack_public_path__ + "img/devices.66c3b4da.jpg";